var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStreamlineProLogomark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #216eb7;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,8.47C0,3.79,3.79,0,8.47,0h19.06C32.21,0,36,3.79,36,8.47v19.06c0,4.68-3.79,8.47-8.47,8.47H8.47c-4.68,0-8.47-3.79-8.47-8.47V8.47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.5,0v5.24c.04,1.99,1.48,4.1,4.45,5.76l9.85,5.5c.76.43,1.39,1.13,1.4,2.06,0,.93-.62,1.64-1.38,2.07-.77.43-1.71.62-2.59.62s-1.83-.19-2.59-.62l-9.72-5.49c-.4-.22-.98-.36-1.62-.36s-1.22.14-1.62.36c-.28.16-.35.28-.36.32.02.04.08.16.36.32l9.93,5.61c.7.4,1.29,1.06,1.29,1.94s-.59,1.54-1.29,1.94c-.71.4-1.57.57-2.38.57s-1.68-.17-2.38-.57l-9.92-5.6c-.4-.23-.99-.37-1.63-.37s-1.23.14-1.63.37c-.29.16-.35.29-.37.33.01.04.08.16.35.32,0,0,24.51,14.29,24.56,14.29.04,0-.55.36-.92.54-.39.19-1.02.43-1.02.43L6.65,22.03c-.75-.43-1.36-1.15-1.35-2.07,0-.92.63-1.62,1.39-2.05.77-.44,1.72-.63,2.61-.63s1.84.19,2.61.63l9.92,5.6c.34.19.84.31,1.4.31s1.06-.12,1.4-.31c.15-.08.22-.15.26-.2-.03-.04-.11-.12-.26-.2l-9.93-5.61c-.76-.43-1.38-1.14-1.38-2.06s.62-1.63,1.38-2.06c.77-.43,1.71-.62,2.6-.62s1.83.19,2.6.62l9.72,5.49c.39.22.97.36,1.61.36s1.22-.14,1.61-.36c.27-.15.34-.27.36-.32-.02-.04-.09-.16-.37-.32l-9.85-5.5c-3.29-1.84-5.42-4.48-5.48-7.46V0h2ZM7.3,19.99h0s0,0,0,0Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineProLogomark);
export default __webpack_public_path__ + "static/media/streamline_pro_logomark.2df6b1025923db8b5011dd4b06b7325b.svg";
export { ForwardRef as ReactComponent };